module.exports = __webpack_public_path__ + "assets/ic-coinspeaker.ad91e98f.svg";